import React,{useEffect} from "react";
import { ConnectButton } from "360dialog-connect-button";
//css & images
import "./WhatsappOnboarding.css";
//components
import Breadcrumbs from "../Components/Breadcrumbs";
//functions
import apiComponents from "../Functions/apiComponents";
import getCookieParam from "../Functions/getCookieParam";

const WhatsappOnboarding = () => {
    // window.onload = () => {
    //     if (getCookieParam('step') === '3') {
    //         document.getElementById('open360dialogbutton').click();
    //     }
    // }
    if (getCookieParam('token') === '') window.location.pathname = `/${getCookieParam('partnerName')}`;
    const handleCallback = (callbackObject) => {
        //Callback function returns the client ID & channel IDs, for which you're enabled to fetch the API key via the Partner API
        console.log("client ID: " + callbackObject.client);
        console.log("channel IDs: " + callbackObject.channels);
    };
    
    return (
        <>
            <Breadcrumbs />
            <div className="step1-container">
                <ConnectButton
                    className="red-button"
                    label="Click here to begin WhatsApp Onboarding"
                    partnerId={apiComponents.partnerId}
                    callback={handleCallback}
                    // queryParameters={{ hosting_type: 'onpremise' }}
                    queryParameters={{ plan_selection: 'basic' }}
                    id="open360dialogbutton"
                />
            </div>
        </>
    );
}
export default WhatsappOnboarding;
